import { FC, ReactNode } from 'react'

type Props = {
  children: ReactNode
  alignItems?: string
}

export const FlexScrollWrapper: FC<Props> = ({
  children,
  alignItems = 'flex-end',
}) => {
  return (
    <div
      style={{
        marginBottom: '36px',
        display: 'flex',
        gridGap: '20px',
        alignItems: alignItems,
        overflow: 'scroll',
        paddingTop: '24px',
      }}
    >
      {children}
    </div>
  )
}
